'use strict';

var React = require("react");
var Belt_Option = require("bs-platform/lib/js/belt_Option.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");
var Avatar$NimbusWeb = require("../../components/Avatar.bs.js");
var Loader$NimbusWeb = require("../../components/Loader.bs.js");
var Typography$NimbusWeb = require("../../components/Typography.bs.js");

require("./Messages.css");

function MessagesUI$Container(Props) {
  var children = Props.children;
  return React.createElement("div", {
              className: "messages-container"
            }, children);
}

var Container = {
  make: MessagesUI$Container
};

function MessagesUI$Sidebar(Props) {
  var children = Props.children;
  var collapse = Props.collapse;
  return React.createElement("div", {
              className: "messages-sidebar",
              style: {
                width: collapse ? "58px" : "300px"
              }
            }, children);
}

var Sidebar = {
  make: MessagesUI$Sidebar
};

function MessagesUI$Content(Props) {
  var children = Props.children;
  return React.createElement("div", {
              className: "messages-content"
            }, children);
}

var Content = {
  make: MessagesUI$Content
};

function MessagesUI$GroupItem(Props) {
  var name = Props.name;
  var avatar = Props.avatar;
  var onClick = Props.onClick;
  var selected = Props.selected;
  var collapseSidebar = Props.collapseSidebar;
  var name$1 = Belt_Option.getWithDefault(name, "Name not found");
  var containerStyle = function (prim, prim$1, prim$2, prim$3, prim$4, prim$5, prim$6, prim$7, prim$8, prim$9, prim$10, prim$11, prim$12, prim$13, prim$14, prim$15, prim$16, prim$17, prim$18, prim$19, prim$20, prim$21, prim$22, prim$23, prim$24, prim$25, prim$26, prim$27, prim$28, prim$29, prim$30, prim$31, prim$32, prim$33, prim$34, prim$35, prim$36, prim$37, prim$38, prim$39, prim$40, prim$41, prim$42, prim$43, prim$44, prim$45, prim$46, prim$47, prim$48, prim$49, prim$50, prim$51, prim$52, prim$53, prim$54, prim$55, prim$56, prim$57, prim$58, prim$59, prim$60, prim$61, prim$62, prim$63, prim$64, prim$65, prim$66, prim$67, prim$68, prim$69, prim$70, prim$71, prim$72, prim$73, prim$74, prim$75, prim$76, prim$77, prim$78, prim$79, prim$80, prim$81, prim$82, prim$83, prim$84, prim$85, prim$86, prim$87, prim$88, prim$89, prim$90, prim$91, prim$92, prim$93, prim$94, prim$95, prim$96, prim$97, prim$98, prim$99, prim$100, prim$101, prim$102, prim$103, prim$104, prim$105, prim$106, prim$107, prim$108, prim$109, prim$110, prim$111, prim$112, prim$113, prim$114, prim$115, prim$116, prim$117, prim$118, prim$119, prim$120, prim$121, prim$122, prim$123, prim$124, prim$125, prim$126, prim$127, prim$128, prim$129, prim$130, prim$131, prim$132, prim$133, prim$134, prim$135, prim$136, prim$137, prim$138, prim$139, prim$140, prim$141, prim$142, prim$143, prim$144, prim$145, prim$146, prim$147, prim$148, prim$149, prim$150, prim$151, prim$152, prim$153, prim$154, prim$155, prim$156, prim$157, prim$158, prim$159, prim$160, prim$161, prim$162, prim$163, prim$164, prim$165, prim$166, prim$167, prim$168, prim$169, prim$170, prim$171, prim$172, prim$173, prim$174, prim$175, prim$176, prim$177, prim$178, prim$179, prim$180, prim$181, prim$182, prim$183, prim$184, prim$185, prim$186, prim$187, prim$188, prim$189, prim$190, prim$191, prim$192, prim$193, prim$194, prim$195, prim$196, prim$197, prim$198, prim$199, prim$200, prim$201, prim$202, prim$203, prim$204, prim$205, prim$206, prim$207, prim$208, prim$209, prim$210, prim$211, prim$212, prim$213, prim$214, prim$215, prim$216, prim$217, prim$218, prim$219, prim$220, prim$221, prim$222, prim$223, prim$224, prim$225, prim$226, prim$227, prim$228, prim$229, prim$230, prim$231, prim$232, prim$233, prim$234, prim$235, prim$236, prim$237, prim$238, prim$239, prim$240, prim$241, prim$242, prim$243, prim$244, prim$245, prim$246, prim$247, prim$248, prim$249, prim$250, prim$251, prim$252, prim$253, prim$254, prim$255, prim$256, prim$257, prim$258, prim$259, prim$260, prim$261, prim$262, prim$263, prim$264, prim$265, prim$266, prim$267, prim$268, prim$269, prim$270, prim$271, prim$272, prim$273, prim$274, prim$275, prim$276, prim$277, prim$278, prim$279, prim$280, prim$281, prim$282, prim$283, prim$284, prim$285, prim$286, prim$287, prim$288, prim$289, prim$290, prim$291, prim$292, prim$293, prim$294, prim$295, prim$296, prim$297, prim$298, prim$299, prim$300, prim$301, prim$302, prim$303, prim$304, prim$305, prim$306, prim$307, prim$308, prim$309, prim$310, prim$311, prim$312, prim$313, prim$314, prim$315, prim$316, prim$317, prim$318, prim$319, prim$320, prim$321, prim$322, prim$323, prim$324, prim$325, prim$326, prim$327, prim$328, prim$329, prim$330, prim$331, prim$332, prim$333, prim$334, prim$335, prim$336, prim$337, prim$338, prim$339, prim$340, prim$341, prim$342, prim$343, prim$344, prim$345, prim$346, prim$347) {
    var tmp = {};
    if (prim !== undefined) {
      tmp.azimuth = Caml_option.valFromOption(prim);
    }
    if (prim$1 !== undefined) {
      tmp.background = Caml_option.valFromOption(prim$1);
    }
    if (prim$2 !== undefined) {
      tmp.backgroundAttachment = Caml_option.valFromOption(prim$2);
    }
    if (prim$3 !== undefined) {
      tmp.backgroundColor = Caml_option.valFromOption(prim$3);
    }
    if (prim$4 !== undefined) {
      tmp.backgroundImage = Caml_option.valFromOption(prim$4);
    }
    if (prim$5 !== undefined) {
      tmp.backgroundPosition = Caml_option.valFromOption(prim$5);
    }
    if (prim$6 !== undefined) {
      tmp.backgroundRepeat = Caml_option.valFromOption(prim$6);
    }
    if (prim$7 !== undefined) {
      tmp.border = Caml_option.valFromOption(prim$7);
    }
    if (prim$8 !== undefined) {
      tmp.borderCollapse = Caml_option.valFromOption(prim$8);
    }
    if (prim$9 !== undefined) {
      tmp.borderColor = Caml_option.valFromOption(prim$9);
    }
    if (prim$10 !== undefined) {
      tmp.borderSpacing = Caml_option.valFromOption(prim$10);
    }
    if (prim$11 !== undefined) {
      tmp.borderStyle = Caml_option.valFromOption(prim$11);
    }
    if (prim$12 !== undefined) {
      tmp.borderTop = Caml_option.valFromOption(prim$12);
    }
    if (prim$13 !== undefined) {
      tmp.borderRight = Caml_option.valFromOption(prim$13);
    }
    if (prim$14 !== undefined) {
      tmp.borderBottom = Caml_option.valFromOption(prim$14);
    }
    if (prim$15 !== undefined) {
      tmp.borderLeft = Caml_option.valFromOption(prim$15);
    }
    if (prim$16 !== undefined) {
      tmp.borderTopColor = Caml_option.valFromOption(prim$16);
    }
    if (prim$17 !== undefined) {
      tmp.borderRightColor = Caml_option.valFromOption(prim$17);
    }
    if (prim$18 !== undefined) {
      tmp.borderBottomColor = Caml_option.valFromOption(prim$18);
    }
    if (prim$19 !== undefined) {
      tmp.borderLeftColor = Caml_option.valFromOption(prim$19);
    }
    if (prim$20 !== undefined) {
      tmp.borderTopStyle = Caml_option.valFromOption(prim$20);
    }
    if (prim$21 !== undefined) {
      tmp.borderRightStyle = Caml_option.valFromOption(prim$21);
    }
    if (prim$22 !== undefined) {
      tmp.borderBottomStyle = Caml_option.valFromOption(prim$22);
    }
    if (prim$23 !== undefined) {
      tmp.borderLeftStyle = Caml_option.valFromOption(prim$23);
    }
    if (prim$24 !== undefined) {
      tmp.borderTopWidth = Caml_option.valFromOption(prim$24);
    }
    if (prim$25 !== undefined) {
      tmp.borderRightWidth = Caml_option.valFromOption(prim$25);
    }
    if (prim$26 !== undefined) {
      tmp.borderBottomWidth = Caml_option.valFromOption(prim$26);
    }
    if (prim$27 !== undefined) {
      tmp.borderLeftWidth = Caml_option.valFromOption(prim$27);
    }
    if (prim$28 !== undefined) {
      tmp.borderWidth = Caml_option.valFromOption(prim$28);
    }
    if (prim$29 !== undefined) {
      tmp.bottom = Caml_option.valFromOption(prim$29);
    }
    if (prim$30 !== undefined) {
      tmp.captionSide = Caml_option.valFromOption(prim$30);
    }
    if (prim$31 !== undefined) {
      tmp.clear = Caml_option.valFromOption(prim$31);
    }
    if (prim$32 !== undefined) {
      tmp.clip = Caml_option.valFromOption(prim$32);
    }
    if (prim$33 !== undefined) {
      tmp.color = Caml_option.valFromOption(prim$33);
    }
    if (prim$34 !== undefined) {
      tmp.content = Caml_option.valFromOption(prim$34);
    }
    if (prim$35 !== undefined) {
      tmp.counterIncrement = Caml_option.valFromOption(prim$35);
    }
    if (prim$36 !== undefined) {
      tmp.counterReset = Caml_option.valFromOption(prim$36);
    }
    if (prim$37 !== undefined) {
      tmp.cue = Caml_option.valFromOption(prim$37);
    }
    if (prim$38 !== undefined) {
      tmp.cueAfter = Caml_option.valFromOption(prim$38);
    }
    if (prim$39 !== undefined) {
      tmp.cueBefore = Caml_option.valFromOption(prim$39);
    }
    if (prim$40 !== undefined) {
      tmp.cursor = Caml_option.valFromOption(prim$40);
    }
    if (prim$41 !== undefined) {
      tmp.direction = Caml_option.valFromOption(prim$41);
    }
    if (prim$42 !== undefined) {
      tmp.display = Caml_option.valFromOption(prim$42);
    }
    if (prim$43 !== undefined) {
      tmp.elevation = Caml_option.valFromOption(prim$43);
    }
    if (prim$44 !== undefined) {
      tmp.emptyCells = Caml_option.valFromOption(prim$44);
    }
    if (prim$45 !== undefined) {
      tmp.float = Caml_option.valFromOption(prim$45);
    }
    if (prim$46 !== undefined) {
      tmp.font = Caml_option.valFromOption(prim$46);
    }
    if (prim$47 !== undefined) {
      tmp.fontFamily = Caml_option.valFromOption(prim$47);
    }
    if (prim$48 !== undefined) {
      tmp.fontSize = Caml_option.valFromOption(prim$48);
    }
    if (prim$49 !== undefined) {
      tmp.fontSizeAdjust = Caml_option.valFromOption(prim$49);
    }
    if (prim$50 !== undefined) {
      tmp.fontStretch = Caml_option.valFromOption(prim$50);
    }
    if (prim$51 !== undefined) {
      tmp.fontStyle = Caml_option.valFromOption(prim$51);
    }
    if (prim$52 !== undefined) {
      tmp.fontVariant = Caml_option.valFromOption(prim$52);
    }
    if (prim$53 !== undefined) {
      tmp.fontWeight = Caml_option.valFromOption(prim$53);
    }
    if (prim$54 !== undefined) {
      tmp.height = Caml_option.valFromOption(prim$54);
    }
    if (prim$55 !== undefined) {
      tmp.left = Caml_option.valFromOption(prim$55);
    }
    if (prim$56 !== undefined) {
      tmp.letterSpacing = Caml_option.valFromOption(prim$56);
    }
    if (prim$57 !== undefined) {
      tmp.lineHeight = Caml_option.valFromOption(prim$57);
    }
    if (prim$58 !== undefined) {
      tmp.listStyle = Caml_option.valFromOption(prim$58);
    }
    if (prim$59 !== undefined) {
      tmp.listStyleImage = Caml_option.valFromOption(prim$59);
    }
    if (prim$60 !== undefined) {
      tmp.listStylePosition = Caml_option.valFromOption(prim$60);
    }
    if (prim$61 !== undefined) {
      tmp.listStyleType = Caml_option.valFromOption(prim$61);
    }
    if (prim$62 !== undefined) {
      tmp.margin = Caml_option.valFromOption(prim$62);
    }
    if (prim$63 !== undefined) {
      tmp.marginTop = Caml_option.valFromOption(prim$63);
    }
    if (prim$64 !== undefined) {
      tmp.marginRight = Caml_option.valFromOption(prim$64);
    }
    if (prim$65 !== undefined) {
      tmp.marginBottom = Caml_option.valFromOption(prim$65);
    }
    if (prim$66 !== undefined) {
      tmp.marginLeft = Caml_option.valFromOption(prim$66);
    }
    if (prim$67 !== undefined) {
      tmp.markerOffset = Caml_option.valFromOption(prim$67);
    }
    if (prim$68 !== undefined) {
      tmp.marks = Caml_option.valFromOption(prim$68);
    }
    if (prim$69 !== undefined) {
      tmp.maxHeight = Caml_option.valFromOption(prim$69);
    }
    if (prim$70 !== undefined) {
      tmp.maxWidth = Caml_option.valFromOption(prim$70);
    }
    if (prim$71 !== undefined) {
      tmp.minHeight = Caml_option.valFromOption(prim$71);
    }
    if (prim$72 !== undefined) {
      tmp.minWidth = Caml_option.valFromOption(prim$72);
    }
    if (prim$73 !== undefined) {
      tmp.orphans = Caml_option.valFromOption(prim$73);
    }
    if (prim$74 !== undefined) {
      tmp.outline = Caml_option.valFromOption(prim$74);
    }
    if (prim$75 !== undefined) {
      tmp.outlineColor = Caml_option.valFromOption(prim$75);
    }
    if (prim$76 !== undefined) {
      tmp.outlineStyle = Caml_option.valFromOption(prim$76);
    }
    if (prim$77 !== undefined) {
      tmp.outlineWidth = Caml_option.valFromOption(prim$77);
    }
    if (prim$78 !== undefined) {
      tmp.overflow = Caml_option.valFromOption(prim$78);
    }
    if (prim$79 !== undefined) {
      tmp.overflowX = Caml_option.valFromOption(prim$79);
    }
    if (prim$80 !== undefined) {
      tmp.overflowY = Caml_option.valFromOption(prim$80);
    }
    if (prim$81 !== undefined) {
      tmp.padding = Caml_option.valFromOption(prim$81);
    }
    if (prim$82 !== undefined) {
      tmp.paddingTop = Caml_option.valFromOption(prim$82);
    }
    if (prim$83 !== undefined) {
      tmp.paddingRight = Caml_option.valFromOption(prim$83);
    }
    if (prim$84 !== undefined) {
      tmp.paddingBottom = Caml_option.valFromOption(prim$84);
    }
    if (prim$85 !== undefined) {
      tmp.paddingLeft = Caml_option.valFromOption(prim$85);
    }
    if (prim$86 !== undefined) {
      tmp.page = Caml_option.valFromOption(prim$86);
    }
    if (prim$87 !== undefined) {
      tmp.pageBreakAfter = Caml_option.valFromOption(prim$87);
    }
    if (prim$88 !== undefined) {
      tmp.pageBreakBefore = Caml_option.valFromOption(prim$88);
    }
    if (prim$89 !== undefined) {
      tmp.pageBreakInside = Caml_option.valFromOption(prim$89);
    }
    if (prim$90 !== undefined) {
      tmp.pause = Caml_option.valFromOption(prim$90);
    }
    if (prim$91 !== undefined) {
      tmp.pauseAfter = Caml_option.valFromOption(prim$91);
    }
    if (prim$92 !== undefined) {
      tmp.pauseBefore = Caml_option.valFromOption(prim$92);
    }
    if (prim$93 !== undefined) {
      tmp.pitch = Caml_option.valFromOption(prim$93);
    }
    if (prim$94 !== undefined) {
      tmp.pitchRange = Caml_option.valFromOption(prim$94);
    }
    if (prim$95 !== undefined) {
      tmp.playDuring = Caml_option.valFromOption(prim$95);
    }
    if (prim$96 !== undefined) {
      tmp.position = Caml_option.valFromOption(prim$96);
    }
    if (prim$97 !== undefined) {
      tmp.quotes = Caml_option.valFromOption(prim$97);
    }
    if (prim$98 !== undefined) {
      tmp.richness = Caml_option.valFromOption(prim$98);
    }
    if (prim$99 !== undefined) {
      tmp.right = Caml_option.valFromOption(prim$99);
    }
    if (prim$100 !== undefined) {
      tmp.size = Caml_option.valFromOption(prim$100);
    }
    if (prim$101 !== undefined) {
      tmp.speak = Caml_option.valFromOption(prim$101);
    }
    if (prim$102 !== undefined) {
      tmp.speakHeader = Caml_option.valFromOption(prim$102);
    }
    if (prim$103 !== undefined) {
      tmp.speakNumeral = Caml_option.valFromOption(prim$103);
    }
    if (prim$104 !== undefined) {
      tmp.speakPunctuation = Caml_option.valFromOption(prim$104);
    }
    if (prim$105 !== undefined) {
      tmp.speechRate = Caml_option.valFromOption(prim$105);
    }
    if (prim$106 !== undefined) {
      tmp.stress = Caml_option.valFromOption(prim$106);
    }
    if (prim$107 !== undefined) {
      tmp.tableLayout = Caml_option.valFromOption(prim$107);
    }
    if (prim$108 !== undefined) {
      tmp.textAlign = Caml_option.valFromOption(prim$108);
    }
    if (prim$109 !== undefined) {
      tmp.textDecoration = Caml_option.valFromOption(prim$109);
    }
    if (prim$110 !== undefined) {
      tmp.textIndent = Caml_option.valFromOption(prim$110);
    }
    if (prim$111 !== undefined) {
      tmp.textShadow = Caml_option.valFromOption(prim$111);
    }
    if (prim$112 !== undefined) {
      tmp.textTransform = Caml_option.valFromOption(prim$112);
    }
    if (prim$113 !== undefined) {
      tmp.top = Caml_option.valFromOption(prim$113);
    }
    if (prim$114 !== undefined) {
      tmp.unicodeBidi = Caml_option.valFromOption(prim$114);
    }
    if (prim$115 !== undefined) {
      tmp.verticalAlign = Caml_option.valFromOption(prim$115);
    }
    if (prim$116 !== undefined) {
      tmp.visibility = Caml_option.valFromOption(prim$116);
    }
    if (prim$117 !== undefined) {
      tmp.voiceFamily = Caml_option.valFromOption(prim$117);
    }
    if (prim$118 !== undefined) {
      tmp.volume = Caml_option.valFromOption(prim$118);
    }
    if (prim$119 !== undefined) {
      tmp.whiteSpace = Caml_option.valFromOption(prim$119);
    }
    if (prim$120 !== undefined) {
      tmp.widows = Caml_option.valFromOption(prim$120);
    }
    if (prim$121 !== undefined) {
      tmp.width = Caml_option.valFromOption(prim$121);
    }
    if (prim$122 !== undefined) {
      tmp.wordSpacing = Caml_option.valFromOption(prim$122);
    }
    if (prim$123 !== undefined) {
      tmp.zIndex = Caml_option.valFromOption(prim$123);
    }
    if (prim$124 !== undefined) {
      tmp.opacity = Caml_option.valFromOption(prim$124);
    }
    if (prim$125 !== undefined) {
      tmp.backgroundOrigin = Caml_option.valFromOption(prim$125);
    }
    if (prim$126 !== undefined) {
      tmp.backgroundSize = Caml_option.valFromOption(prim$126);
    }
    if (prim$127 !== undefined) {
      tmp.backgroundClip = Caml_option.valFromOption(prim$127);
    }
    if (prim$128 !== undefined) {
      tmp.borderRadius = Caml_option.valFromOption(prim$128);
    }
    if (prim$129 !== undefined) {
      tmp.borderTopLeftRadius = Caml_option.valFromOption(prim$129);
    }
    if (prim$130 !== undefined) {
      tmp.borderTopRightRadius = Caml_option.valFromOption(prim$130);
    }
    if (prim$131 !== undefined) {
      tmp.borderBottomLeftRadius = Caml_option.valFromOption(prim$131);
    }
    if (prim$132 !== undefined) {
      tmp.borderBottomRightRadius = Caml_option.valFromOption(prim$132);
    }
    if (prim$133 !== undefined) {
      tmp.borderImage = Caml_option.valFromOption(prim$133);
    }
    if (prim$134 !== undefined) {
      tmp.borderImageSource = Caml_option.valFromOption(prim$134);
    }
    if (prim$135 !== undefined) {
      tmp.borderImageSlice = Caml_option.valFromOption(prim$135);
    }
    if (prim$136 !== undefined) {
      tmp.borderImageWidth = Caml_option.valFromOption(prim$136);
    }
    if (prim$137 !== undefined) {
      tmp.borderImageOutset = Caml_option.valFromOption(prim$137);
    }
    if (prim$138 !== undefined) {
      tmp.borderImageRepeat = Caml_option.valFromOption(prim$138);
    }
    if (prim$139 !== undefined) {
      tmp.boxShadow = Caml_option.valFromOption(prim$139);
    }
    if (prim$140 !== undefined) {
      tmp.columns = Caml_option.valFromOption(prim$140);
    }
    if (prim$141 !== undefined) {
      tmp.columnCount = Caml_option.valFromOption(prim$141);
    }
    if (prim$142 !== undefined) {
      tmp.columnFill = Caml_option.valFromOption(prim$142);
    }
    if (prim$143 !== undefined) {
      tmp.columnGap = Caml_option.valFromOption(prim$143);
    }
    if (prim$144 !== undefined) {
      tmp.columnRule = Caml_option.valFromOption(prim$144);
    }
    if (prim$145 !== undefined) {
      tmp.columnRuleColor = Caml_option.valFromOption(prim$145);
    }
    if (prim$146 !== undefined) {
      tmp.columnRuleStyle = Caml_option.valFromOption(prim$146);
    }
    if (prim$147 !== undefined) {
      tmp.columnRuleWidth = Caml_option.valFromOption(prim$147);
    }
    if (prim$148 !== undefined) {
      tmp.columnSpan = Caml_option.valFromOption(prim$148);
    }
    if (prim$149 !== undefined) {
      tmp.columnWidth = Caml_option.valFromOption(prim$149);
    }
    if (prim$150 !== undefined) {
      tmp.breakAfter = Caml_option.valFromOption(prim$150);
    }
    if (prim$151 !== undefined) {
      tmp.breakBefore = Caml_option.valFromOption(prim$151);
    }
    if (prim$152 !== undefined) {
      tmp.breakInside = Caml_option.valFromOption(prim$152);
    }
    if (prim$153 !== undefined) {
      tmp.rest = Caml_option.valFromOption(prim$153);
    }
    if (prim$154 !== undefined) {
      tmp.restAfter = Caml_option.valFromOption(prim$154);
    }
    if (prim$155 !== undefined) {
      tmp.restBefore = Caml_option.valFromOption(prim$155);
    }
    if (prim$156 !== undefined) {
      tmp.speakAs = Caml_option.valFromOption(prim$156);
    }
    if (prim$157 !== undefined) {
      tmp.voiceBalance = Caml_option.valFromOption(prim$157);
    }
    if (prim$158 !== undefined) {
      tmp.voiceDuration = Caml_option.valFromOption(prim$158);
    }
    if (prim$159 !== undefined) {
      tmp.voicePitch = Caml_option.valFromOption(prim$159);
    }
    if (prim$160 !== undefined) {
      tmp.voiceRange = Caml_option.valFromOption(prim$160);
    }
    if (prim$161 !== undefined) {
      tmp.voiceRate = Caml_option.valFromOption(prim$161);
    }
    if (prim$162 !== undefined) {
      tmp.voiceStress = Caml_option.valFromOption(prim$162);
    }
    if (prim$163 !== undefined) {
      tmp.voiceVolume = Caml_option.valFromOption(prim$163);
    }
    if (prim$164 !== undefined) {
      tmp.objectFit = Caml_option.valFromOption(prim$164);
    }
    if (prim$165 !== undefined) {
      tmp.objectPosition = Caml_option.valFromOption(prim$165);
    }
    if (prim$166 !== undefined) {
      tmp.imageResolution = Caml_option.valFromOption(prim$166);
    }
    if (prim$167 !== undefined) {
      tmp.imageOrientation = Caml_option.valFromOption(prim$167);
    }
    if (prim$168 !== undefined) {
      tmp.alignContent = Caml_option.valFromOption(prim$168);
    }
    if (prim$169 !== undefined) {
      tmp.alignItems = Caml_option.valFromOption(prim$169);
    }
    if (prim$170 !== undefined) {
      tmp.alignSelf = Caml_option.valFromOption(prim$170);
    }
    if (prim$171 !== undefined) {
      tmp.flex = Caml_option.valFromOption(prim$171);
    }
    if (prim$172 !== undefined) {
      tmp.flexBasis = Caml_option.valFromOption(prim$172);
    }
    if (prim$173 !== undefined) {
      tmp.flexDirection = Caml_option.valFromOption(prim$173);
    }
    if (prim$174 !== undefined) {
      tmp.flexFlow = Caml_option.valFromOption(prim$174);
    }
    if (prim$175 !== undefined) {
      tmp.flexGrow = Caml_option.valFromOption(prim$175);
    }
    if (prim$176 !== undefined) {
      tmp.flexShrink = Caml_option.valFromOption(prim$176);
    }
    if (prim$177 !== undefined) {
      tmp.flexWrap = Caml_option.valFromOption(prim$177);
    }
    if (prim$178 !== undefined) {
      tmp.justifyContent = Caml_option.valFromOption(prim$178);
    }
    if (prim$179 !== undefined) {
      tmp.order = Caml_option.valFromOption(prim$179);
    }
    if (prim$180 !== undefined) {
      tmp.textDecorationColor = Caml_option.valFromOption(prim$180);
    }
    if (prim$181 !== undefined) {
      tmp.textDecorationLine = Caml_option.valFromOption(prim$181);
    }
    if (prim$182 !== undefined) {
      tmp.textDecorationSkip = Caml_option.valFromOption(prim$182);
    }
    if (prim$183 !== undefined) {
      tmp.textDecorationStyle = Caml_option.valFromOption(prim$183);
    }
    if (prim$184 !== undefined) {
      tmp.textEmphasis = Caml_option.valFromOption(prim$184);
    }
    if (prim$185 !== undefined) {
      tmp.textEmphasisColor = Caml_option.valFromOption(prim$185);
    }
    if (prim$186 !== undefined) {
      tmp.textEmphasisPosition = Caml_option.valFromOption(prim$186);
    }
    if (prim$187 !== undefined) {
      tmp.textEmphasisStyle = Caml_option.valFromOption(prim$187);
    }
    if (prim$188 !== undefined) {
      tmp.textUnderlinePosition = Caml_option.valFromOption(prim$188);
    }
    if (prim$189 !== undefined) {
      tmp.fontFeatureSettings = Caml_option.valFromOption(prim$189);
    }
    if (prim$190 !== undefined) {
      tmp.fontKerning = Caml_option.valFromOption(prim$190);
    }
    if (prim$191 !== undefined) {
      tmp.fontLanguageOverride = Caml_option.valFromOption(prim$191);
    }
    if (prim$192 !== undefined) {
      tmp.fontSynthesis = Caml_option.valFromOption(prim$192);
    }
    if (prim$193 !== undefined) {
      tmp.forntVariantAlternates = Caml_option.valFromOption(prim$193);
    }
    if (prim$194 !== undefined) {
      tmp.fontVariantCaps = Caml_option.valFromOption(prim$194);
    }
    if (prim$195 !== undefined) {
      tmp.fontVariantEastAsian = Caml_option.valFromOption(prim$195);
    }
    if (prim$196 !== undefined) {
      tmp.fontVariantLigatures = Caml_option.valFromOption(prim$196);
    }
    if (prim$197 !== undefined) {
      tmp.fontVariantNumeric = Caml_option.valFromOption(prim$197);
    }
    if (prim$198 !== undefined) {
      tmp.fontVariantPosition = Caml_option.valFromOption(prim$198);
    }
    if (prim$199 !== undefined) {
      tmp.all = Caml_option.valFromOption(prim$199);
    }
    if (prim$200 !== undefined) {
      tmp.glyphOrientationVertical = Caml_option.valFromOption(prim$200);
    }
    if (prim$201 !== undefined) {
      tmp.textCombineUpright = Caml_option.valFromOption(prim$201);
    }
    if (prim$202 !== undefined) {
      tmp.textOrientation = Caml_option.valFromOption(prim$202);
    }
    if (prim$203 !== undefined) {
      tmp.writingMode = Caml_option.valFromOption(prim$203);
    }
    if (prim$204 !== undefined) {
      tmp.shapeImageThreshold = Caml_option.valFromOption(prim$204);
    }
    if (prim$205 !== undefined) {
      tmp.shapeMargin = Caml_option.valFromOption(prim$205);
    }
    if (prim$206 !== undefined) {
      tmp.shapeOutside = Caml_option.valFromOption(prim$206);
    }
    if (prim$207 !== undefined) {
      tmp.clipPath = Caml_option.valFromOption(prim$207);
    }
    if (prim$208 !== undefined) {
      tmp.clipRule = Caml_option.valFromOption(prim$208);
    }
    if (prim$209 !== undefined) {
      tmp.mask = Caml_option.valFromOption(prim$209);
    }
    if (prim$210 !== undefined) {
      tmp.maskBorder = Caml_option.valFromOption(prim$210);
    }
    if (prim$211 !== undefined) {
      tmp.maskBorderMode = Caml_option.valFromOption(prim$211);
    }
    if (prim$212 !== undefined) {
      tmp.maskBorderOutset = Caml_option.valFromOption(prim$212);
    }
    if (prim$213 !== undefined) {
      tmp.maskBorderRepeat = Caml_option.valFromOption(prim$213);
    }
    if (prim$214 !== undefined) {
      tmp.maskBorderSlice = Caml_option.valFromOption(prim$214);
    }
    if (prim$215 !== undefined) {
      tmp.maskBorderSource = Caml_option.valFromOption(prim$215);
    }
    if (prim$216 !== undefined) {
      tmp.maskBorderWidth = Caml_option.valFromOption(prim$216);
    }
    if (prim$217 !== undefined) {
      tmp.maskClip = Caml_option.valFromOption(prim$217);
    }
    if (prim$218 !== undefined) {
      tmp.maskComposite = Caml_option.valFromOption(prim$218);
    }
    if (prim$219 !== undefined) {
      tmp.maskImage = Caml_option.valFromOption(prim$219);
    }
    if (prim$220 !== undefined) {
      tmp.maskMode = Caml_option.valFromOption(prim$220);
    }
    if (prim$221 !== undefined) {
      tmp.maskOrigin = Caml_option.valFromOption(prim$221);
    }
    if (prim$222 !== undefined) {
      tmp.maskPosition = Caml_option.valFromOption(prim$222);
    }
    if (prim$223 !== undefined) {
      tmp.maskRepeat = Caml_option.valFromOption(prim$223);
    }
    if (prim$224 !== undefined) {
      tmp.maskSize = Caml_option.valFromOption(prim$224);
    }
    if (prim$225 !== undefined) {
      tmp.maskType = Caml_option.valFromOption(prim$225);
    }
    if (prim$226 !== undefined) {
      tmp.backgroundBlendMode = Caml_option.valFromOption(prim$226);
    }
    if (prim$227 !== undefined) {
      tmp.isolation = Caml_option.valFromOption(prim$227);
    }
    if (prim$228 !== undefined) {
      tmp.mixBlendMode = Caml_option.valFromOption(prim$228);
    }
    if (prim$229 !== undefined) {
      tmp.boxDecorationBreak = Caml_option.valFromOption(prim$229);
    }
    if (prim$230 !== undefined) {
      tmp.boxSizing = Caml_option.valFromOption(prim$230);
    }
    if (prim$231 !== undefined) {
      tmp.caretColor = Caml_option.valFromOption(prim$231);
    }
    if (prim$232 !== undefined) {
      tmp.navDown = Caml_option.valFromOption(prim$232);
    }
    if (prim$233 !== undefined) {
      tmp.navLeft = Caml_option.valFromOption(prim$233);
    }
    if (prim$234 !== undefined) {
      tmp.navRight = Caml_option.valFromOption(prim$234);
    }
    if (prim$235 !== undefined) {
      tmp.navUp = Caml_option.valFromOption(prim$235);
    }
    if (prim$236 !== undefined) {
      tmp.outlineOffset = Caml_option.valFromOption(prim$236);
    }
    if (prim$237 !== undefined) {
      tmp.resize = Caml_option.valFromOption(prim$237);
    }
    if (prim$238 !== undefined) {
      tmp.textOverflow = Caml_option.valFromOption(prim$238);
    }
    if (prim$239 !== undefined) {
      tmp.grid = Caml_option.valFromOption(prim$239);
    }
    if (prim$240 !== undefined) {
      tmp.gridArea = Caml_option.valFromOption(prim$240);
    }
    if (prim$241 !== undefined) {
      tmp.gridAutoColumns = Caml_option.valFromOption(prim$241);
    }
    if (prim$242 !== undefined) {
      tmp.gridAutoFlow = Caml_option.valFromOption(prim$242);
    }
    if (prim$243 !== undefined) {
      tmp.gridAutoRows = Caml_option.valFromOption(prim$243);
    }
    if (prim$244 !== undefined) {
      tmp.gridColumn = Caml_option.valFromOption(prim$244);
    }
    if (prim$245 !== undefined) {
      tmp.gridColumnEnd = Caml_option.valFromOption(prim$245);
    }
    if (prim$246 !== undefined) {
      tmp.gridColumnGap = Caml_option.valFromOption(prim$246);
    }
    if (prim$247 !== undefined) {
      tmp.gridColumnStart = Caml_option.valFromOption(prim$247);
    }
    if (prim$248 !== undefined) {
      tmp.gridGap = Caml_option.valFromOption(prim$248);
    }
    if (prim$249 !== undefined) {
      tmp.gridRow = Caml_option.valFromOption(prim$249);
    }
    if (prim$250 !== undefined) {
      tmp.gridRowEnd = Caml_option.valFromOption(prim$250);
    }
    if (prim$251 !== undefined) {
      tmp.gridRowGap = Caml_option.valFromOption(prim$251);
    }
    if (prim$252 !== undefined) {
      tmp.gridRowStart = Caml_option.valFromOption(prim$252);
    }
    if (prim$253 !== undefined) {
      tmp.gridTemplate = Caml_option.valFromOption(prim$253);
    }
    if (prim$254 !== undefined) {
      tmp.gridTemplateAreas = Caml_option.valFromOption(prim$254);
    }
    if (prim$255 !== undefined) {
      tmp.gridTemplateColumns = Caml_option.valFromOption(prim$255);
    }
    if (prim$256 !== undefined) {
      tmp.gridTemplateRows = Caml_option.valFromOption(prim$256);
    }
    if (prim$257 !== undefined) {
      tmp.willChange = Caml_option.valFromOption(prim$257);
    }
    if (prim$258 !== undefined) {
      tmp.hangingPunctuation = Caml_option.valFromOption(prim$258);
    }
    if (prim$259 !== undefined) {
      tmp.hyphens = Caml_option.valFromOption(prim$259);
    }
    if (prim$260 !== undefined) {
      tmp.lineBreak = Caml_option.valFromOption(prim$260);
    }
    if (prim$261 !== undefined) {
      tmp.overflowWrap = Caml_option.valFromOption(prim$261);
    }
    if (prim$262 !== undefined) {
      tmp.tabSize = Caml_option.valFromOption(prim$262);
    }
    if (prim$263 !== undefined) {
      tmp.textAlignLast = Caml_option.valFromOption(prim$263);
    }
    if (prim$264 !== undefined) {
      tmp.textJustify = Caml_option.valFromOption(prim$264);
    }
    if (prim$265 !== undefined) {
      tmp.wordBreak = Caml_option.valFromOption(prim$265);
    }
    if (prim$266 !== undefined) {
      tmp.wordWrap = Caml_option.valFromOption(prim$266);
    }
    if (prim$267 !== undefined) {
      tmp.animation = Caml_option.valFromOption(prim$267);
    }
    if (prim$268 !== undefined) {
      tmp.animationDelay = Caml_option.valFromOption(prim$268);
    }
    if (prim$269 !== undefined) {
      tmp.animationDirection = Caml_option.valFromOption(prim$269);
    }
    if (prim$270 !== undefined) {
      tmp.animationDuration = Caml_option.valFromOption(prim$270);
    }
    if (prim$271 !== undefined) {
      tmp.animationFillMode = Caml_option.valFromOption(prim$271);
    }
    if (prim$272 !== undefined) {
      tmp.animationIterationCount = Caml_option.valFromOption(prim$272);
    }
    if (prim$273 !== undefined) {
      tmp.animationName = Caml_option.valFromOption(prim$273);
    }
    if (prim$274 !== undefined) {
      tmp.animationPlayState = Caml_option.valFromOption(prim$274);
    }
    if (prim$275 !== undefined) {
      tmp.animationTimingFunction = Caml_option.valFromOption(prim$275);
    }
    if (prim$276 !== undefined) {
      tmp.transition = Caml_option.valFromOption(prim$276);
    }
    if (prim$277 !== undefined) {
      tmp.transitionDelay = Caml_option.valFromOption(prim$277);
    }
    if (prim$278 !== undefined) {
      tmp.transitionDuration = Caml_option.valFromOption(prim$278);
    }
    if (prim$279 !== undefined) {
      tmp.transitionProperty = Caml_option.valFromOption(prim$279);
    }
    if (prim$280 !== undefined) {
      tmp.transitionTimingFunction = Caml_option.valFromOption(prim$280);
    }
    if (prim$281 !== undefined) {
      tmp.backfaceVisibility = Caml_option.valFromOption(prim$281);
    }
    if (prim$282 !== undefined) {
      tmp.perspective = Caml_option.valFromOption(prim$282);
    }
    if (prim$283 !== undefined) {
      tmp.perspectiveOrigin = Caml_option.valFromOption(prim$283);
    }
    if (prim$284 !== undefined) {
      tmp.transform = Caml_option.valFromOption(prim$284);
    }
    if (prim$285 !== undefined) {
      tmp.transformOrigin = Caml_option.valFromOption(prim$285);
    }
    if (prim$286 !== undefined) {
      tmp.transformStyle = Caml_option.valFromOption(prim$286);
    }
    if (prim$287 !== undefined) {
      tmp.justifyItems = Caml_option.valFromOption(prim$287);
    }
    if (prim$288 !== undefined) {
      tmp.justifySelf = Caml_option.valFromOption(prim$288);
    }
    if (prim$289 !== undefined) {
      tmp.placeContent = Caml_option.valFromOption(prim$289);
    }
    if (prim$290 !== undefined) {
      tmp.placeItems = Caml_option.valFromOption(prim$290);
    }
    if (prim$291 !== undefined) {
      tmp.placeSelf = Caml_option.valFromOption(prim$291);
    }
    if (prim$292 !== undefined) {
      tmp.appearance = Caml_option.valFromOption(prim$292);
    }
    if (prim$293 !== undefined) {
      tmp.caret = Caml_option.valFromOption(prim$293);
    }
    if (prim$294 !== undefined) {
      tmp.caretAnimation = Caml_option.valFromOption(prim$294);
    }
    if (prim$295 !== undefined) {
      tmp.caretShape = Caml_option.valFromOption(prim$295);
    }
    if (prim$296 !== undefined) {
      tmp.userSelect = Caml_option.valFromOption(prim$296);
    }
    if (prim$297 !== undefined) {
      tmp.maxLines = Caml_option.valFromOption(prim$297);
    }
    if (prim$298 !== undefined) {
      tmp.marqueeDirection = Caml_option.valFromOption(prim$298);
    }
    if (prim$299 !== undefined) {
      tmp.marqueeLoop = Caml_option.valFromOption(prim$299);
    }
    if (prim$300 !== undefined) {
      tmp.marqueeSpeed = Caml_option.valFromOption(prim$300);
    }
    if (prim$301 !== undefined) {
      tmp.marqueeStyle = Caml_option.valFromOption(prim$301);
    }
    if (prim$302 !== undefined) {
      tmp.overflowStyle = Caml_option.valFromOption(prim$302);
    }
    if (prim$303 !== undefined) {
      tmp.rotation = Caml_option.valFromOption(prim$303);
    }
    if (prim$304 !== undefined) {
      tmp.rotationPoint = Caml_option.valFromOption(prim$304);
    }
    if (prim$305 !== undefined) {
      tmp.alignmentBaseline = Caml_option.valFromOption(prim$305);
    }
    if (prim$306 !== undefined) {
      tmp.baselineShift = Caml_option.valFromOption(prim$306);
    }
    if (prim$307 !== undefined) {
      tmp.clip = Caml_option.valFromOption(prim$307);
    }
    if (prim$308 !== undefined) {
      tmp.clipPath = Caml_option.valFromOption(prim$308);
    }
    if (prim$309 !== undefined) {
      tmp.clipRule = Caml_option.valFromOption(prim$309);
    }
    if (prim$310 !== undefined) {
      tmp.colorInterpolation = Caml_option.valFromOption(prim$310);
    }
    if (prim$311 !== undefined) {
      tmp.colorInterpolationFilters = Caml_option.valFromOption(prim$311);
    }
    if (prim$312 !== undefined) {
      tmp.colorProfile = Caml_option.valFromOption(prim$312);
    }
    if (prim$313 !== undefined) {
      tmp.colorRendering = Caml_option.valFromOption(prim$313);
    }
    if (prim$314 !== undefined) {
      tmp.cursor = Caml_option.valFromOption(prim$314);
    }
    if (prim$315 !== undefined) {
      tmp.dominantBaseline = Caml_option.valFromOption(prim$315);
    }
    if (prim$316 !== undefined) {
      tmp.fill = Caml_option.valFromOption(prim$316);
    }
    if (prim$317 !== undefined) {
      tmp.fillOpacity = Caml_option.valFromOption(prim$317);
    }
    if (prim$318 !== undefined) {
      tmp.fillRule = Caml_option.valFromOption(prim$318);
    }
    if (prim$319 !== undefined) {
      tmp.filter = Caml_option.valFromOption(prim$319);
    }
    if (prim$320 !== undefined) {
      tmp.floodColor = Caml_option.valFromOption(prim$320);
    }
    if (prim$321 !== undefined) {
      tmp.floodOpacity = Caml_option.valFromOption(prim$321);
    }
    if (prim$322 !== undefined) {
      tmp.glyphOrientationHorizontal = Caml_option.valFromOption(prim$322);
    }
    if (prim$323 !== undefined) {
      tmp.glyphOrientationVertical = Caml_option.valFromOption(prim$323);
    }
    if (prim$324 !== undefined) {
      tmp.imageRendering = Caml_option.valFromOption(prim$324);
    }
    if (prim$325 !== undefined) {
      tmp.kerning = Caml_option.valFromOption(prim$325);
    }
    if (prim$326 !== undefined) {
      tmp.lightingColor = Caml_option.valFromOption(prim$326);
    }
    if (prim$327 !== undefined) {
      tmp.markerEnd = Caml_option.valFromOption(prim$327);
    }
    if (prim$328 !== undefined) {
      tmp.markerMid = Caml_option.valFromOption(prim$328);
    }
    if (prim$329 !== undefined) {
      tmp.markerStart = Caml_option.valFromOption(prim$329);
    }
    if (prim$330 !== undefined) {
      tmp.pointerEvents = Caml_option.valFromOption(prim$330);
    }
    if (prim$331 !== undefined) {
      tmp.shapeRendering = Caml_option.valFromOption(prim$331);
    }
    if (prim$332 !== undefined) {
      tmp.stopColor = Caml_option.valFromOption(prim$332);
    }
    if (prim$333 !== undefined) {
      tmp.stopOpacity = Caml_option.valFromOption(prim$333);
    }
    if (prim$334 !== undefined) {
      tmp.stroke = Caml_option.valFromOption(prim$334);
    }
    if (prim$335 !== undefined) {
      tmp.strokeDasharray = Caml_option.valFromOption(prim$335);
    }
    if (prim$336 !== undefined) {
      tmp.strokeDashoffset = Caml_option.valFromOption(prim$336);
    }
    if (prim$337 !== undefined) {
      tmp.strokeLinecap = Caml_option.valFromOption(prim$337);
    }
    if (prim$338 !== undefined) {
      tmp.strokeLinejoin = Caml_option.valFromOption(prim$338);
    }
    if (prim$339 !== undefined) {
      tmp.strokeMiterlimit = Caml_option.valFromOption(prim$339);
    }
    if (prim$340 !== undefined) {
      tmp.strokeOpacity = Caml_option.valFromOption(prim$340);
    }
    if (prim$341 !== undefined) {
      tmp.strokeWidth = Caml_option.valFromOption(prim$341);
    }
    if (prim$342 !== undefined) {
      tmp.textAnchor = Caml_option.valFromOption(prim$342);
    }
    if (prim$343 !== undefined) {
      tmp.textRendering = Caml_option.valFromOption(prim$343);
    }
    if (prim$344 !== undefined) {
      tmp.rubyAlign = Caml_option.valFromOption(prim$344);
    }
    if (prim$345 !== undefined) {
      tmp.rubyMerge = Caml_option.valFromOption(prim$345);
    }
    if (prim$346 !== undefined) {
      tmp.rubyPosition = Caml_option.valFromOption(prim$346);
    }
    return tmp;
  };
  return React.createElement("div", {
              className: "messages-group-item-container",
              role: "button",
              style: selected ? containerStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, "1px solid #555", undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined) : containerStyle(undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined, undefined),
              onClick: onClick
            }, React.createElement(Avatar$NimbusWeb.make, {
                  src: avatar,
                  alt: "Picture of " + name$1,
                  size: /* Small */0
                }), collapseSidebar ? null : React.createElement(Typography$NimbusWeb.make, {
                    className: "messages-group-item-name",
                    value: name$1
                  }));
}

var GroupItem = {
  make: MessagesUI$GroupItem
};

function MessagesUI$Sample(Props) {
  var name = Props.name;
  var src = Props.src;
  var collapseSidebar = Props.collapseSidebar;
  return React.createElement(MessagesUI$GroupItem, {
              groupId: "a",
              name: name,
              avatar: src,
              onClick: (function (param) {
                  
                }),
              selected: false,
              collapseSidebar: collapseSidebar
            });
}

var Sample = {
  make: MessagesUI$Sample
};

function MessagesUI$Empty$GroupList(Props) {
  var loading = Props.loading;
  return React.createElement("div", {
              className: "messages-empty-container"
            }, loading ? React.createElement(Loader$NimbusWeb.Circular.Simple.make, {
                    size: /* Small */0
                  }) : React.createElement(Typography$NimbusWeb.make, {
                    textAlign: "center",
                    className: "messages-empty-text",
                    value: "Book a session to message"
                  }));
}

var GroupList = {
  make: MessagesUI$Empty$GroupList
};

function MessagesUI$Empty$GroupUnselected(Props) {
  return React.createElement("div", {
              className: "messages-empty-container-2"
            }, React.createElement(Typography$NimbusWeb.make, {
                  textAlign: "center",
                  className: "messages-empty-text",
                  value: "Select someone to start messaging"
                }));
}

var GroupUnselected = {
  make: MessagesUI$Empty$GroupUnselected
};

var Empty = {
  GroupList: GroupList,
  GroupUnselected: GroupUnselected
};

exports.Container = Container;
exports.Sidebar = Sidebar;
exports.Content = Content;
exports.GroupItem = GroupItem;
exports.Sample = Sample;
exports.Empty = Empty;
/*  Not a pure module */
